<template>
    <div>
        <div class="py-3">
            <div class="alert alert-danger" v-if="error">
                {{ error }}
            </div>
            <div class="alert alert-success" v-if="responseData">
                <p>These properties were added</p>
                <ul>
                    <li v-for="team in responseData.teams" :key="team.id">{{ team.name }}</li>
                </ul>
                <div v-if="responseData.group">
                    Under group {{ responseData.group.name }}.
                </div>
            </div>
            <div class="alert alert-danger"
                v-if="responseData && responseData.notAdded && responseData.notAdded.length > 0">
                    <p>These properties were not added:</p>
                    <ul>
                        <li v-for="link in responseData.notAdded" :key="link">{{ link }}</li>
                    </ul>
            </div>
            <div class="mb-3">
                <strong>Add one TripAdvisor link per line</strong>
            </div>
            <textarea class="form-control mb-3" v-model="tripAdvisorLinks"></textarea>
            <div class="mb-3">
                <strong>Add by ID</strong>
            </div>
            <div class="mb-3">
                ID: <input type="text" v-model="watcherId" />
                
            </div>
            <div class="custom-control custom-switch my-3 d-flex align-items-center">
                <input type="checkbox" v-model="shouldCreateGroup" class="custom-control-input" id="customSwitches">
                <label class="custom-control-label" for="customSwitches">Create a group</label>
                <input type="text" placeholder="Enter group name" v-model="newGroupName" v-show="shouldCreateGroup" class="form-control" />
            </div>
            <div class="custom-control custom-switch my-3">
                <input type="checkbox" v-model="onlyOverview" class="custom-control-input" id="overview">
                <label class="custom-control-label" for="overview">Only overview</label>
            </div>
            <div class="text-right">
                <button class="btn btn-primary btn-lg" type="button" @click="create"
                    :disabled="(tripAdvisorLinks === '' && watcherId === '') || (shouldCreateGroup && newGroupName === '') || loading">
                    <span v-if="loading">Creating...</span>
                    <span v-else>Create</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AdministrationMixin from './AdministrationMixin';
export default {
    props: {
        partner: {
            type: Object,
            default: null
        }
    },
    mixins: [AdministrationMixin],
    data() {
        return {
            tripAdvisorLinks: '',
            shouldCreateGroup: false,
            onlyOverview: false,
            newGroupName: '',
            error: '',
            loading: false,
            responseData: null,
            watcherId: ''
        }
    },
    computed: {
        linksArray() {
            return this.tripAdvisorLinks.split('\n');
        }
    },
    methods: {
        async create() {
            let index = 1;
            for (let line of this.linksArray) {
                if (!line.includes('tripadvisor') && this.watcherId === '') {
                    this.error = `Not a valid TripAdvisor link on line ${index}.`;
                    return;
                }
                index++;
            }
            const postData = {
                tripAdvisorLinks: this.linksArray,
                watcherId: this.watcherId
            };
            if (this.onlyOverview) {
                postData.active = 0;
            }
            if (this.shouldCreateGroup) postData.groupName = this.newGroupName;
            this.loading = true;
            const response = await axios.post(this.createTeamsUrl, postData);
            this.loading = false;
            this.responseData = response.data;
        }
    }
};
</script>

<style scoped>
    textarea {
        min-height: 200px;
    }
</style>